import React from 'react';

const Error = () => {
  return (
    <div>Sorry, there was a problem fetching the quiz.</div>
  );
};

export default Error;
